import amplitude from 'amplitude-js'

const APP_ID_DEVELOPMENT = 'a22841f16c5f2a241e24a882864a2a43'
const APP_ID_PRODUCTION = '736df8fd0ce68ae08f2e753e49fd8aaf'

export const initAmplitude = () => {
  amplitude.getInstance().init(process.env.NODE_ENV === 'production' ? APP_ID_PRODUCTION : APP_ID_DEVELOPMENT)
}

export const setAmplitudeUserDevice = (deviceId: string) => {
  amplitude.getInstance().setDeviceId(deviceId)
}

export const setAmplitudeUserId = (userId: string | null) => {
  amplitude.getInstance().setUserId(userId)
}

export const setAmplitudeUserProperties = (properties: Record<string, any>) => {
  amplitude.getInstance().setUserProperties(properties)
}

export const logAmplitudeEvent = (eventType: string, eventProperties?: any, callback?: amplitude.Callback) => {
  amplitude.getInstance().logEvent(eventType, eventProperties, callback)
}
